import { render, staticRenderFns } from "./ProposedDeal.vue?vue&type=template&id=6d8dc736&"
import script from "./ProposedDeal.vue?vue&type=script&lang=js&"
export * from "./ProposedDeal.vue?vue&type=script&lang=js&"
import style0 from "./ProposedDeal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports